// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"onfido-sdk-ui-Select-wrapper","select":"onfido-sdk-ui-Select-select"};


//////////////////
// WEBPACK FOOTER
// ./components/Select/style.css
// module id = 384
// module chunks = 1